// extracted by mini-css-extract-plugin
export default {"container":"stats-panel_container__9GaVm","title":"stats-panel_title__i85hL","count":"stats-panel_count__9eIod"};